module.exports = __webpack_public_path__ + "static/media/comic2016.mobile.d64960e1.png";